export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL
  ? process.env.REACT_APP_BACKEND_URL
  : "http://localhost:8080";
// : "http://192.168.10.114:8080";


export const WEBSOCKET_URL = process.env.REACT_APP_WEBSOCKET_URL
  ? process.env.REACT_APP_WEBSOCKET_URL
  : "http://localhost:8080";
//: "http://192.168.10.114:8080";


export const USA_STATES = [
  "Alabama",
  "Alaska",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "Florida",
  "Georgia",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Pennsylvania",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming",
];

export const PROFILE_INFO_CONFIG = [
  {
    field: "relationship_status",
    label: "Relationship Status",
    defaultValue: "",
    icon: "",
  },
  {
    field: "occupation",
    label: "Occupation",
    defaultValue: "",
    icon: "",
  },
  {
    field: "horoscope",
    label: "Horoscope",
    defaultValue: "",
    icon: "",
  },
  {
    field: "children_wish",
    label: "Kids",
    defaultValue: "",
    icon: "",
  },
  {
    field: "sibling",
    label: "Sibling",
    defaultValue: "",
    icon: "",
  },
  {
    field: "pet",
    label: "Pet",
    defaultValue: "",
    icon: "",
  },
];

export const PROFILE_INFO_FIELDS = PROFILE_INFO_CONFIG.reduce(
  (fields, item) => {
    fields[item.field] = item.defaultValue;
    return fields;
  },
  {}
);

export const PROFILE_LABELS = PROFILE_INFO_CONFIG.reduce((labels, item) => {
  labels[item.field] = item.label;
  return labels;
}, {});

export const PROFILE_ICONS = PROFILE_INFO_CONFIG.reduce((icons, item) => {
  icons[item.field] = item.icon;
  return icons;
}, {});

export const HOROSCOPES = [
  "Aries",
  "Taurus",
  "Gemini",
  "Cancer",
  "Leo",
  "Virgo",
  "Libra",
  "Scorpio",
  "Sagittarius",
  "Capricorn",
  "Aquarius",
  "Pisces",
  "Other",
];

export const OCCUPATIONS = [
  "Engineer",
  "Doctor",
  "Teacher",
  "Movie Entertainment",
  "Music Entertainment",
  "Student",
  "Employee",
  "Professional Sport",
  "Business & Investment",
  "Law & order",
  "Blogger or Influencer",
  "It & Computer",
  "CEO or Manager",
  "Other",
];

export const RELATIONSHIP_STATUSES = [
  "Single",
  "In a relationship",
  "Married",
  "Divorced",
  "It's complicated",
];

export const PET_OPTIONS = [
  "Yes, cat",
  "Yes, dog",
  "Yes",
  "No"
];

export const SIBLING_OPTIONS = [
  "Brother",
  "Sister",
  "Brother & Sister",
  "No"
];

export const KIDS_OPTIONS = [
  "Yes",
  "Yes, I want more",
  "No",
  "No, but I wish"
];

export const REPORT_REASONS = [
  { value: "inappropriate_behavior", label: "Inappropriate Behavior" },
  { value: "spam", label: "Spam" },
  { value: "fake_profile", label: "Fake Profile" },
  { value: "harassment", label: "Harassment" },
  { value: "other", label: "Other" },
];